export function categoryTypesSlider() {
    $(".category-types-slider").slick({
        slidesToScroll: 1,
        infinite: false,
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><title>Arrow right</title><path fill="#560332" d="M9 0L7.364 1.636l6.194 6.195H0v2.338h13.558l-6.194 6.195L9 18l9-9z"/></svg></button>',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><title>Arrow left</title><path fill="#560332" d="M9 0l1.636 1.636-6.194 6.195H18v2.338H4.442l6.194 6.195L9 18 0 9z"/></svg></button > ',
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 3.3
                }
            },
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 4.3
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/categoryTypesSlider.js